import { render } from "./StudentInfo.vue?vue&type=template&id=4bb55206&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"

import "./StudentInfo.vue?vue&type=style&index=0&id=4bb55206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb55206"]])

export default __exports__